import React from 'react';
import { colors as theme } from '../../theme';

const brandColors = {
  darkGray: theme.bg,
  mediumGray: theme.surface1,
  lightGray: theme.surface3,
  silver: theme.textMuted,
  white: theme.text,
  purple: '#AF52DE',
};

/**
 * IsometricInput Component
 *
 * Handles input for isometric exercises (holds logged in seconds).
 * - Lets the client enter their actual hold time; the target is shown once, at the top of the exercise
 *   ("2 × 20s hold"), not on every set (owner, 24 October 2026)
 * - Auto-completes when a duration is entered
 *
 * Props:
 * - set: Current set data
 * - setIndex: Index of the set
 * - onChange: Callback(setIndex, field, value)
 * - isLocked: Boolean to disable input
 */
const IsometricInput = ({
  set,
  setIndex,
  onChange,
  isLocked = false,
}) => {
  return (
    <div style={styles.container}>
      {/* Actual hold time input */}
      <div style={styles.inputWrapper}>
        <input
          type="number"
          inputMode="numeric"
          aria-label={`Set ${setIndex + 1}: seconds held`}
          value={set.duration_seconds || ''}
          onChange={(e) => onChange(setIndex, 'duration_seconds', e.target.value)}
          style={{
            ...styles.input,
            borderColor: set.completed ? 'rgba(52, 199, 89, 0.5)' : brandColors.lightGray,
            opacity: isLocked ? 0.6 : 1,
          }}
          disabled={isLocked}
          min="1"
        />
        <span style={styles.unit}>sec</span>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flex: 1,
  },
  inputWrapper: {
    position: 'relative',
    flex: 1,
    display: 'flex',
    alignItems: 'center',
  },
  input: {
    width: '100%',
    backgroundColor: theme.bg,
    border: '1px solid',
    borderRadius: '8px',
    padding: '10px 40px 10px 12px',
    fontSize: '15px',
    fontWeight: '600',
    color: theme.text,
    outline: 'none',
    textAlign: 'center',
    boxSizing: 'border-box',
    MozAppearance: 'textfield',
  },
  unit: {
    position: 'absolute',
    right: '10px',
    fontSize: '11px',
    fontWeight: '600',
    color: brandColors.silver,
    pointerEvents: 'none',
  },
};

export default IsometricInput;
